function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.4
}, React.createElement("g", {
  id: "download-button-active",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M14.8235294,6.35294118 L10.5882353,6.35294118 L10.5882353,0 L4.23529412,0 L4.23529412,6.35294118 L0,6.35294118 L7.41176471,13.7647059 L14.8235294,6.35294118 Z M0,15.8823529 L0,18 L14.8235294,18 L14.8235294,15.8823529 L0,15.8823529 Z",
  id: "Shape"
})));

const SvgDownloadIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDownloadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/downloadIcon.fbe3fc27.svg";
export { ForwardRef as ReactComponent };